const initTabs = () => {
	console.log('init tabs');
	const tabs = document.querySelectorAll('.accordion nav > button');
	const contents = document.querySelectorAll('.accordion .content');
	const select = document.querySelectorAll('.accordion select');

	tabs.forEach(tab => {
		tab.addEventListener('click', e => {
			e.preventDefault();
			removeActiveTab();
			addActiveTab(tab);
		});
	});

	if (select.length) {
		select[0].addEventListener('change', (e) => {
			e.preventDefault();
			removeActiveTab();
			addActiveTab(e.target.value);
		});
	}

	const addActiveTab = tab => {
		const id = tab.nodeName === 'BUTTON' ? tab.dataset.tab : tab;

		if (tab.nodeName === 'BUTTON') {
			tab.classList.add('btn-blue');
			select[0].value = id;
		}
		else {
			const btn = document.querySelectorAll(`.accordion nav > button[data-tab="${id}"]`);
			btn[0].classList.add('btn-blue');
		}

		const matchingContent = document.querySelectorAll(`.accordion .content[data-tab="${id}"]`);
		matchingContent[0].classList.add('is-active');
	}

	const removeActiveTab = () => {
		tabs.forEach(tab => {
			tab.classList.remove('btn-blue');
		});
		contents.forEach(content => {
			content.classList.remove('is-active');
		});
	}
};

export default {
	init() {
		initTabs();
	}
}
